module.exports = __webpack_public_path__ + "img/extlink-white.1c4b1f33.svg";